module.exports = __webpack_public_path__ + "static/media/listCaixaMobile.6b2c5916.png";